module.exports = __webpack_public_path__ + "9345fa5ddf14aa7f1eab96d0990ca40e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/Japsen.jpg
// module id = 879
// module chunks = 0